export default "__VITE_ASSET__DjbNdecG__"